import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendService, BackendResponse } from 'auth/src/lib/services';
import { PagedList } from 'src/app/shared/models/paged-list.model';
import { EmailRecipient } from 'src/app/shared/modals/email-send-modal/models/email-recipient.interface';

@Injectable({
    providedIn: 'root'
})
export class ReportEmailService {

    constructor(private _httpService: BackendService) { }
    
    public searchUsers(query: string, page: number = 1, pageSize: number = 20): Observable<PagedList<EmailRecipient>> {
        return this._httpService.get<PagedList<EmailRecipient>>('searchUsers', [], [
            { name: 'search', value: query },
            { name: 'page', value: page.toString() },
            { name: 'pageSize', value: pageSize.toString() }
        ]).pipe(
                map(response => response.data),
        );
    }
    
    public sendReportByEmail(jobId: string, jobName: string, userIds: string[]): Observable<BackendResponse<void>> {
        return this._httpService.post<void>('sendReportLinkByEmail', {
            jobId: jobId,
            jobName: jobName,
            userIds: userIds
        });
    }
}
